// --------------------------------------------------------
// HEADER LOGOUNT - headerLogount
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useCallback, useEffect } from "react";
import {
  BodyHeader,
  ButtonLogountHeader,
  ContainerHeader,
  LogoHeader,
} from "./HeaderLogount.styled";
import logo from "../../assets/imgs/logo.svg";
import IconLogount from "../../assets/imgs/logout.svg";
import * as login from "../../store/actions/login";
import { useAppDispatch } from "../..";
import { useSelector } from "react-redux";
import jwtDecode from "jwt-decode";
import { UserService } from "../../core/http/service/UserService";
import { AppointmentService } from "../../core/http/service/AppointmentService";
import OpenAppointmentsModal from "../openAppointmentsModal/OpenAppointmentsModal";
import { useState } from "react";
import { Roles } from "../../enums/Roles";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// HEADER LOGOUNT INTERFACE
// --------------------------------------------------------

interface IheaderLogount {}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const HeaderLogount = ({}: IheaderLogount) => {
  // --------------------------------------------------------
  // HEADER LOGOUNT PRIVATE DECLARATIONS
  // --------------------------------------------------------

  // --------------------------------------------------------
  const { token, currentProfile } = useSelector((state: any)=> state.login)
  const [showOpenAppointmentsModal, setShowOpenAppointmentsModal] = useState(false);
  const [pendingAppointments, setPendingAppointments] = useState<any[]>([]);
  const dispatch = useAppDispatch();

  const fetchLogout = useCallback(async () => {
    const rolesToWarn = ["MED", "ENF", "PSI", "NUT", Roles.MED, Roles.ENF, Roles.PSI, Roles.NUT];
    const isHealthProfessional = rolesToWarn.includes(currentProfile);

    if (isHealthProfessional) {
      const appointmentService = new AppointmentService();
      try {
        const pendingResponse: any = await appointmentService.getPendingAppointments();
        const pendingData = pendingResponse.data.data || [];

        if (pendingData && pendingData.length > 0) {
          setPendingAppointments(pendingData);
          setShowOpenAppointmentsModal(true);
          return;
        }
      } catch (error) {
        console.error("Erro ao buscar atendimentos pendentes no logout:", error);
      }
    }

    await dispatch(login.logout());
  }, [dispatch, currentProfile]);

  const confirmLogout = async () => {
    setShowOpenAppointmentsModal(false);
    await dispatch(login.logout());
  };

  const testRefreshToken = useCallback(async ()=>{
    try{
      const service: UserService = new UserService();
      const userInfoResponse: any = await service.getInfo();
    }catch(error: any){
      if(error.response.data.errors[0] === 'RefreshToken inválido'){
        alert('Sessão expirada, faça login novamente!')
        await dispatch(login.logout())
      }
    }
  }, [])

  useEffect(()=>{
    if(token !== null){
      const decoded_token: any = jwtDecode(token)
      const expDate = new Date(decoded_token.exp*1000)
      const now = new Date()
      if(now > expDate){
        testRefreshToken();
      }
    }
  }, [])

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <ContainerHeader>
        <BodyHeader>
          <LogoHeader src={logo} />
          <ButtonLogountHeader onClick={() => fetchLogout()}>
            <img src={IconLogount} alt="" />
            <p>Sair</p>
          </ButtonLogountHeader>
        </BodyHeader>
      </ContainerHeader>
      <OpenAppointmentsModal
        visible={showOpenAppointmentsModal}
        appointments={pendingAppointments}
        isLogout={true}
        onConfirm={confirmLogout}
        onCancel={() => setShowOpenAppointmentsModal(false)}
      />
    </>
  );
  // --------------------------------------------------------
};

export default HeaderLogount;
